/* eslint-disable no-unused-vars */
import $ from 'jquery';
import Cookies from './Cookies';

import router from '../../router';

import { getAPIUrls } from './API_URLS';

const ENVIRONMENT = import.meta.env.VITE_ENV_TYPE?.toUpperCase() ?? 'DEVELOPMENT';

const API = { ...getAPIUrls(ENVIRONMENT) };

console.log('API ENV_TYPE', ENVIRONMENT);
console.log('CSC_API_URL', API.CSC_API_URL);

API.Call = function (method = 'POST', url, objectsToPass = {}, content_type = 'application/json', signal = undefined) {
	return fetchAPI(method, url, objectsToPass, content_type, signal);
};

export default API;

/**
 * @deprecated Use {@link fetchAPI} instead.
 */
function CallAPI_NEW(method = 'POST', url, objectsToPass = {}, callbackToSendJSON, content_type = 'application/json', is_in_maintenance_mode) {
	if (!$.isFunction(callbackToSendJSON)) {
		callbackToSendJSON = function () {};
	}
	if (url == null || url == '') {
		//No Url Given
		callbackToSendJSON({
			error: {
				status: 404,
				code: 2, //0002,
				title: 'MISSING_URL',
				description: 'No url was passed.',
			},
		});
		return;
	}

	let timeout = 0; //No` timeout
	try {
		if (is_in_maintenance_mode != undefined && is_in_maintenance_mode == true) {
			timeout = 7000;
		} //7 Second timeout while in maintenance mode
	} catch (error) {
		console.error(error);
	}

	//Check if there is an internet connection;
	if (navigator.onLine || true == true) {
		//There is an internet connection;
		const token = Cookies.readCookie('token');
		const data = content_type == 'application/json' ? JSON.stringify(objectsToPass) : objectsToPass;
		console.log('now sending ajax', url);
		$.ajax({
			url: url,
			headers: {
				Authorization: `Bearer ${token}`,
				'Content-Type': `${content_type}`,
			},
			method: method,
			data: data,
			mode: 'cors',
			timeout: timeout,
			success: function (results) {
				console.log('[API RESPONSE] Response:', results);
				callbackToSendJSON(results);
			},
			error: function (error) {
				var returnedJSON = undefined;

				console.log('ERROR', error);

				if (error.responseJSON == undefined || error.status == 0) {
					//Server is down or No Internet
					console.warn('NO NETWORK CONNECTION FOUND', error.response, navigator.online);
					returnedJSON = {
						error: {
							status: 404,
							code: 0, //0000,
							title: 'NO_NETWORK_CONNECTION',
							description: 'There is no internet connection.',
						},
					};
				} else if (error.responseJSON != undefined || null) {
					returnedJSON = error.responseJSON;
					console.log('[Some Error Occured in API] RAW: ', error.responseJSON);
				} else {
					returnedJSON = {
						error: {
							status: 404,
							code: 1, //0001,
							title: 'UNKNOWN_ERROR',
							description: 'No response was sent back from the API.',
						},
					};
				}
				console.log('[Some Error Occurred in API] RESPONSE BEING RETURNED:', returnedJSON);
				callbackToSendJSON(returnedJSON, true);
			},
		});
	} else {
		//There is no internet connection; Try to find a cache else return with no internet and let the caller handle it;
		console.error('NO INTERNET CONNECTION!!!');
		callbackToSendJSON({
			error: {
				status: 404,
				code: 0, //0000,
				title: 'NO_NETWORK_CONNECTION',
				description: 'There is no internet connection.',
			},
		});
	}
}

async function fetchAPI(method = 'POST', url, objectsToPass = {}, content_type = 'application/json', signal, skip_token_refresh = false) {
	if (!url) {
		throw new Error('MISSING_URL: No URL was passed.');
	}

	const token = objectsToPass?.bearer_token ?? Cookies.readCookie('token');
	const headers = {
		'Authorization': `Bearer ${token}`,
		...(content_type == 'FormData' ? {} : { 'Content-Type': content_type }),
	};
	// Only stringify objectsToPass if it's not a GET or HEAD request

	let body = content_type === 'application/json' ? JSON.stringify(objectsToPass) : objectsToPass;
	if (['GET', 'HEAD'].includes(method)) {
		body = null;
	}

	let fetch_options = {
		method,
		headers,
		mode: 'cors',
		body,
	};

	if (signal != undefined) {
		fetch_options.signal = signal;
	}

	try {
		const response = await fetch(url, fetch_options);

		if (response.status === 403) {
			const result = await response.json();
			if (result.error?.title === 'EXPIRED_TOKEN') {
				if (skip_token_refresh == true) {
					return result;
				}
				return await fetchRefreshAccessToken({ method, url, objectsToPass, content_type });
			}
			return result;
		}

		// if (!response.ok) {
		// 	throw new Error('API request failed.');
		// }

		return await response.json();
	} catch (error) {
		// If error is triggered on purpose using the AbortController() API
		if (error.name === 'AbortError') {
			throw error;
		}
		console.error('Error in fetchAPI:', error);
		//TODO: Copy CSC and only return no network connection error with the following condition if (error.responseJSON == undefined || error.status == 0) {
		return {
			error: {
				status: 404,
				code: 0, //0000,
				title: 'NO_NETWORK_CONNECTION',
				description: 'There is no internet connection.',
			},
		};

		// Fallback to the CallAPI_NEW method using jQuery's AJAX
		// return await new Promise((resolve, reject) => {
		// 	CallAPI_NEW(
		// 		method,
		// 		url,
		// 		objectsToPass,
		// 		(result) => {
		// 			if (result && result.error) {
		// 				reject(result.error);
		// 			} else {
		// 				console.log('result', result);
		// 				resolve(result);
		// 			}
		// 		},
		// 		content_type
		// 	);
		// });
	}
}

let refresh_access_token_in_flight_promise = undefined;

/**
 * Runs at most one refresh-token exchange at a time. Concurrent callers await the same promise
 * so one-time-use refresh tokens are not consumed twice.
 */
async function await_single_flight_refresh() {
	if (refresh_access_token_in_flight_promise != undefined) {
		return await refresh_access_token_in_flight_promise;
	}

	const refresh_token = Cookies.readCookie('refresh_token');

	refresh_access_token_in_flight_promise = (async () => {
		try {
			const response = await fetchAPI('POST', `${API.COBRA_PORTAL_API_URL}/users/refresh-token`, { refresh_token }, 'application/json', undefined, true);

			if (response.error != undefined) {
				router.push({
					path: `/login`,
					query: { redirect_to_previous_page: true },
				});
				throw new Error(response.error.description);
			}

			Cookies.createCookie('token', response.access_token, 60, { cross_domain: true });
			Cookies.createCookie('refresh_token', response.refresh_token, 60, { cross_domain: true });

			return response;
		} finally {
			refresh_access_token_in_flight_promise = undefined;
		}
	})();

	return await refresh_access_token_in_flight_promise;
}

async function fetchRefreshAccessToken(original_API_call_arguments) {
	try {
		const refresh_response = await await_single_flight_refresh();

		if (original_API_call_arguments != undefined) {
			return await fetchAPI(original_API_call_arguments.method, original_API_call_arguments.url, original_API_call_arguments.objectsToPass, original_API_call_arguments.content_type);
		}
		return refresh_response;
	} catch (error) {
		throw new Error('Unable to refresh access token.');
	}
}
